import { initContainer } from "~/container";

export default defineNuxtPlugin(() => {
  var container = initContainer();

  return {
    provide: {
      container,
    },
  };
});
